export default __webpack_public_path__ + "static/media/Eye_5_F_C6.d5215c4b.svg";